
global.String.prototype.capitalize = function () {
  return this.replace(/\b\w/g, function (l) {
    return l.toUpperCase();
  });
};

SVGElement.prototype.attr = function (attrName, value) {
  return typeof value == "undefined" ? this.getAttribute(attrName) : this.setAttribute(attrName, value);
}
SVGElement.prototype.hasClass = function (className) { return (this.attr("class").split(" ").indexOf(className) !== -1); };
SVGElement.prototype.addClass = function (className) {
  this.hasClass(className) ? null : this.attr("class", `${this.attr("class")} ${className}`);
}
SVGElement.prototype.removeClass = function (className) {
  this.attr("class",
    this.attr("class").replace(className, "").trim());
}

HTMLElement.prototype.attr = function (attrName, value) {
  return typeof value == "undefined" ? this.getAttribute(attrName) : this.setAttribute(attrName, value);
}
HTMLElement.prototype.hasClass = function (className) { return (this.attr("class").split(" ").indexOf(className) !== -1); };
HTMLElement.prototype.addClass = function (className) {
  this.hasClass(className) ? null : this.attr("class", `${this.attr("class")} ${className}`);
}
HTMLElement.prototype.removeClass = function (className) {
  this.attr("class",
    this.attr("class").replace(className, "").trim());
}

HTMLElement.prototype.window = window

NodeList.prototype.forEach = Array.prototype.forEach;